"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ruLocaleData = require("i18next-icu/locale-data/ru");
exports.default = ruLocaleData;
//# sourceMappingURL=ru.js.map